  <template>
  <div class="">
    <div>
      <img src="../assets/banner.png" alt="">
    </div>
    <div class="container joinus">
      <div class="title">
        <h1>
          招聘信息
        </h1>
        <aside>
          Job Offers
        </aside>
      </div>
      <h3>
        大客户销售经理
      </h3>
      <h5>
        职责描述：
      </h5>
      <p>
        1、负责完成IDC客户销售计划，跟踪销售进度、完成销售目标。 <br>
        2、跨区域，跨部门协调资源，确保公司销售业务的发展要求得到不断满足。<br>
        3、负责重点客户开拓和拜访工作，定期维护好客户关系。<br>
        4、全面掌握公司的新产品，能够较快的、有针对性的进行市场推广。<br>
        5、负责相关行业的市场调研与客户信息收集，并制定有针对性的营销思路。

      </p>
      <h5>
        任职要求：
      </h5>
      <p>
        1、本科及以上学历。<br>
        2、通信，IT系统集成，互联网技术等相关经验优先。<br>
        3、勤奋好学，理解能力强，有较高的情商。<br>
        5、有一年以上idc销售经验。<br>
        6、有亲和力，善于沟通表达，责任心强的有志青年。<br>
      </p>
      <h3>
        网络工程师
      </h3>
      <h5>
        职责描述：
      </h5>
      <p>
        1.负责维护IDC数据中心核心网络和边缘网络；<br>
        2.负责IDC数据中心网络管理和运维，保证网络符合安全要求<br>
        3.对IDC数据中心网络故障进行排查和处理，完成故障报告；<br>
        4.根据IDC数据中心网络运行情况提出优化方案，完成网络变更实施；<br>
        5.完成数据中心核心网络运行报告；<br>
        6.根据公司要求完成每月的网络运行报告<br>
        7.负责和甲方技术人员技术对接<br>
        8.配合供应商远程割接测试等。<br>
      </p>
      <h5>
        任职要求：
      </h5>
      <p>
        1.本科以上学历，3年大型数据中心核心网络维护工作经验；<br>
        2.对BGP、OSPF、ISIS等路由协议及应用有深入理解；<br>
        3.熟练配置华为、华三、思科等品牌的中高端网络设备；<br>
        4.具备华为、华三、网络设备3年以上维护经验；<br>
        5.熟悉网络监控及分析手段及工具，有网络、安全实施、规划经验；<br>
        6.熟悉网络安全管理和防火墙、WAF、IDS、IPS、负载均衡等网络安全产品；<br>
        7.具备CCIE或同级别认证（H3CIE/HCIE/JNCIE）优先；<br>
        8.熟悉一般的OSN传输设备，定期梳理设备及光缆路由情况，并制定优化调整方案；<br>
        9. 熟练使用Microsoft office系列办公软件，具备优秀的文档编写能力；<br>
        10.熟悉LINUX系统的一般配置等。<br>


      </p>
      <h3>
        运维工程师

      </h3>
      <h5>

        职责描述：
      </h5>
      <p>

        1、负责IDC数据中心服务器、存储与网络设备的维护;<br>
        2、负责Windows、Linux系统平台下的各服务应用部署，日常维护分析解决；<br>
        3、负责Windows、Linux系统平台下数据库部署，优化，常见问题解决；<br>
        4、负责各服务器的权限分配，帐号管理；<br>
        5、负责客户模拟环境的搭建及维护。<br>



      </p>
      <h5>
        任职要求：
      </h5>
      <p>


        1.精通shell/Python/Perl等1至2种编程语言;<br>
        2.熟悉网络基础知识;<br>
        3.深入理解Linux操作系统;<br>
        4.熟悉开源的监控平台工具，比如：Ganglia、Nagios等;<br>
        5.熟练掌握Shell脚本熟悉Awk、Sed等基础工具;<br>
        6.熟悉分布式计算或者存储系统，比如Hadoop/Hbase/Storm等;<br>
        7.熟悉TCP/IP、HTTP等网络协议，精通socket网络编程。<br>
      </p>
      <h3>
        运维工程师

      </h3>
      <h5>
        职责描述：
      </h5>
      <p>


        1、互联网与工控网络安全缺陷分析及测试;<br>
        2、编写相关分析报告;<br>
        3、信息安全项目的实施与服务;<br>
        4、信息安全方案编写，试验环境搭建及安全培训。<br>




      </p>
      <h5>
        任职要求：

      </h5>
      <p>

        1、计算机相关专业本科以上学历，有进行网络安全技术研究的优先;<br>
        2、熟悉各种脚本语言及各类web服务器架构，有较强的代码阅读和分析能力，至少掌握一门编程语言;<br>
        3、能够在代码层面理解如sql注入、xss，csrf、文件包含、远程代码执行、截断上传、验证绕过等原理;<br>
        4、熟练运用各种网络安全检测工具，如扫描类、注入类、代理类、抓包类等并能自己开发一些小工具。<br>

      </p>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Footer from '../components/Footer'
  export default {
    name: 'Introduction',
    components: {
      Footer
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  img {
    width: 100%;
  }
  h1 {
    font-size: 4.6rem;
    color: #fe9901;
  }
  aside {
    font-size: 1.6rem;
    color: #999;
    text-transform: uppercase;
  }
  .title {
    padding-left: 30px;
    border-left: 1px solid #ccc;
    margin-bottom: 4rem;
  }
  .joinus {
    margin-top: 6rem;
    padding-bottom: 5rem;
  }
  h3 {
    font-size: 2.6rem;
    color: #333;
    margin-bottom: 4rem;
    font-weight: bold;
  }
  h5 {
    font-size: 1.8rem;
    color: #333;
    margin-bottom: 3rem;
    font-weight: bold;
  }
  p {
    font-size: 1.8rem;
    color: #333;
    margin-bottom: 3rem;
    font-weight: normal;
    line-height: 3.5rem;
  }
</style>
